import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch, patchAtivaUsuario } from "../../api/api";

// Ativar novo usuário
export const ativaUsuario = async (email: string) => {  
  return await patchAtivaUsuario<IRespostaFuncao<any[]>>(`/usuarios/ativa-usuario`, {email});
};

// Obtem usuarios empresas
export const obtemUsuarios = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/usuarios`);
};

// Obtem usuario id
export const obtemUsuario = async (firebaseId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/usuarios/${firebaseId}`);
};

// Obtem usuario id
export const obtemPapelUsuario = async (firebaseId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/usuarios/${firebaseId}/obtem-papel`);
};

// Criar usuario
export const criarUsuario = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/usuarios/cria-usuario`,
    payload
  );
};

// Atualizar usuario
export const atualizarUsuario = async (
  userId: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/usuarios/${userId}/atualiza-usuario`,
    payload
  );
};

// Deletar usuario
export const deletarUsuario = async (
  userId: string,
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/usuarios/${userId}/remove-usuario`
  );
}; 

// Atribui empresas ao usuario
export const atribuiEmpresasUsuario = async (
  userId: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/usuarios/${userId}/atribui-empresas`,
    payload
  );
};

// Atribui paineis ao usuario
export const atribuiPaineisUsuario = async (
  userId: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/usuarios/${userId}/atribui-paineis`,
    payload
  );
};

// Atribui paineis ao usuario
export const desatribuirPaineisUsuario = async (
  userId: string,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/usuarios/${userId}/desatribui-todos-paineis`,
    {}
  );
};

// Envia email ativacao
export const enviaEmailAtivacao = async (
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/usuarios/envia-email-ativacao`,
    payload
  );
};

// Obtem paineis do usuario
export const obtemPaineisUsuario = async (
  firebaseId: string
): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>(
    `/usuarios/${firebaseId}/obtem-paineis`
  );
};

// Obtem dados de config dos relatorios/reports Embedded
export const obtemEmbedConfigUsuario = async (
  firebaseId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/usuarios/${firebaseId}/embed-config`,
    payload
  );
};

